import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import logoIzquierdo from '@/assets/logo_durango.png'
import logoDerecho from '@/assets/logo_salud.jpg'

function getBase64FromImage(imgUrl) {
  return new Promise((resolve) => {
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      resolve(canvas.toDataURL('image/png'))
    }
    img.src = imgUrl
  })
}

function formatearFecha(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  }).format(new Date(fecha))
}

function formatMayusculas(palabras) {
  return palabras.toUpperCase()
}

function formatearFechaHora(fecha) {
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(fecha))
}

// function campo(doc, label, value, x, y, width = 70) {
//   doc.setFontSize(8)
//   doc.setFont('helvetica', 'normal')
//   doc.text(label, x, y)
//   doc.setFontSize(9)

//   doc.setFont('helvetica', 'bold')
//   doc.text(value || '', x, y + 4)

//   doc.setDrawColor(0)
//   doc.line(x, y + 5, x + width, y + 5)
// }
function campo(doc, label, value, x, y, width = 70, minHeight = 10) {
  doc.setFontSize(8)
  doc.setTextColor('000')

  doc.setFont('helvetica', 'bold')
  doc.text(label, x, y)

  doc.setFontSize(9)
  doc.setFont('helvetica', 'normal')
  doc.setTextColor('000   ')

  const text = value || ''
  const textLines = doc.splitTextToSize(text, width - 4)
  const boxHeight = Math.max(minHeight, textLines.length * 4 + 2)

  // Caja gris SIN borde
  doc.setFillColor(245, 245, 245)
  doc.rect(x, y + 1, width, boxHeight, 'F')

  // Texto dentro
  doc.text(textLines, x + 2, y + 5)

   // 🔥 Borde inferior delgado
doc.setDrawColor(208, 208, 208)      // gris elegante
doc.setLineWidth(0.3)
doc.line(x, y +1 + boxHeight, x + width, y+1 + boxHeight)

  return y + boxHeight + 8
}

// function campo(doc, label, value, x, y, width = 70) {
//   // Label
//   doc.setFontSize(8)
//   doc.setTextColor('000')

//   doc.setFont('helvetica', 'bold')
//   doc.text(label, x, y)

//   // Valor
//   doc.setFontSize(9)
//   doc.setFont('helvetica', 'normal')
//   doc.setTextColor(100)

//   const text = value || ''
//   const lines = doc.splitTextToSize(text, width)

//   doc.text(lines, x, y + 4)

//   // Línea inferior según el alto del texto
//   const lineHeight = lines.length * 4
//   doc.setDrawColor(0)
//   doc.setLineWidth(0.2)
//   doc.line(x, y + 1 + lineHeight, x + width, y + 1 + lineHeight)

//   // Retornar la nueva Y (muy útil)
//   return y + 8 + lineHeight
// }

function tituloSeccion(doc, texto, y) {
  doc.setFontSize(10)
  doc.setFont('helvetica', 'bold')
  doc.setTextColor(0)
  doc.text(texto.toUpperCase(), 14, y)

  doc.setDrawColor(0)
  doc.setLineWidth(0.6)
  doc.line(14, y + 2, 200, y + 2)

  return y + 8
}

async function generarFichaSocioeconomica(paciente, estudio) {
  const doc = new jsPDF('p', 'mm', 'letter')
  const pageWidth = doc.internal.pageSize.getWidth()


  const logo1 = await getBase64FromImage(logoIzquierdo)
  const logo2 = await getBase64FromImage(logoDerecho)


  // Logo izquierdo
  doc.addImage(logo1, 'PNG', 14, 5, 45, 30)

  // Logo derecho
  doc.addImage(logo2, 'PNG', pageWidth - 60, 5, 45, 30)

  doc.setFontSize(12)
  doc.setFont('helvetica', 'bold')
  doc.text('FICHA SOCIOECONÓMICA INICIAL', pageWidth / 2, 15, { align: 'center' })

  // FECHA DE ATENCION
  doc.setTextColor(100)

  doc.setFont('helvetica', 'normal')
  doc.setFontSize(8)
  doc.text('FECHA DE ATENCIÓN', pageWidth / 2, 20, { align: 'center' })

  doc.setFont('helvetica', 'bold')
  doc.setFontSize(9)
  doc.text(formatearFecha(estudio.fechaCreacion), pageWidth / 2, 24, { align: 'center' })

  // FECHA DE REPORTE
  doc.setFont('helvetica', 'normal')
  doc.setFontSize(8)
  doc.text('FECHA Y HORA DE GENERACION:', pageWidth / 2, 30, { align: 'center' })

  doc.setFont('helvetica', 'bold')
  doc.setFontSize(9)
  doc.text(formatearFechaHora(new Date), pageWidth / 2, 34, { align: 'center' })


  let y = 45
  y = tituloSeccion(doc, 'DATOS GENERALES DEL PACIENTE', y)
  campo(doc, 'Folio:', '021001010', 14, y, 50,6)

  y += 12

  campo(doc, 'Nombre:', paciente.nombres + ' ' + paciente.apellidoPaterno + ' ' + paciente.apellidoMaterno, 14, y, 186,6)

  y += 12
  campo(doc, 'Fecha de nacimiento:', formatearFecha(paciente.fechaNacimiento), 14, y, 55,6)
  campo(doc, 'Sexo:', estudio.sexo, 75, y, 65,6)
  campo(doc, 'Estado civil:', estudio.estadoCivil, 145, y, 55,6)

  y += 12
  campo(doc, 'Escolaridad:',estudio.escolaridad, 14, y, 186,6)

  y += 12
  campo(doc, 'Ocupación:', estudio.ocupacion, 14, y, 90,6)
  campo(doc, 'Religión:', estudio.religion, 110, y, 90,6)

  y += 12
campo(doc, 'Originario de:', estudio.originario, 14, y, 186,6)

  y += 12
  campo(doc, 'Derechohabiente de:', estudio.derechohabiente, 14, y, 186,6)

  y += 12
campo(doc, 'Domicilio permanente:', estudio.domicilioPermanente, 14, y, 186,6)

  y += 12
  campo(doc, 'Domicilio temporal:', estudio.domicilioTemporal, 14, y, 186,6)

  y += 12
  campo(doc, 'Nombre del familiar o del responsable:', estudio.nombreFamiliarResponsable, 14, y, 186,6)

  y += 12
  y = campo(doc, 'Diagnóstico Médico: ',estudio.diagnosticoMedico, 14, y, 186,6)

  const startY = y
  const columnWidth = 90
  const gap = 6

  let grupoFammiliarData = [{ grupo: 'Ninguno', calif: 2 }]

  autoTable(doc, {
    startY,
    margin: { left: 14 },
    tableWidth: columnWidth,
    head: [['Grupo familiar', 'Calificación']],
    body: grupoFammiliarData.map(i => [i.grupo, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  // TABLA OCUPACIÓN
  let ocupacionData = [{ grupo: 'Ninguno', calif: 3 }]
  const secondColumnX = 14 + columnWidth + gap

  autoTable(doc, {
    startY,
    margin: { left: secondColumnX },
    tableWidth: columnWidth,
    head: [['Ocupación', 'Calificación']],
    body: ocupacionData.map(i => [i.grupo, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  y = doc.lastAutoTable.finalY + 12

  doc.addPage()
  y = 20

  y = tituloSeccion(doc, 'SISTEMA DE CUOTAS DE RECUPERACIÓN (NIVEL NACIONAL)', y)

  // TABLA DE INGRESOS MENSUALES
  let ingresos = [
    { ingreso: 'Jefe de Familia', calif: 1000 },
    { ingreso: 'Esposo (a)', calif: 0 },
    { ingreso: 'Hijo (a)', calif: 0 },
    { ingreso: 'Otro', calif: 1000 },
    { ingreso: 'Total', calif: 1000 },
  ]

  // TABLA DE EGRESOS MENSUALES 
  let egresos = [
    { egreso: 'Alimentación', calif: 4000 },
    { egreso: 'Renta o Predio', calif: 4000 },
    { egreso: 'Agua', calif: 4000 },
    { egreso: 'Luz', calif: 4000 },
    { egreso: 'Combustible', calif: 4000 },
    { egreso: 'Transporte', calif: 4000 },
    { egreso: 'Educación', calif: 4000 },
    { egreso: 'Consumos Adicionales', calif: 4000 },
    { egreso: 'Total', calif: 4000 },
  ]

  const startYTabla = y

  autoTable(doc, {
    startY: startYTabla,
    margin: { left: 14 },
    tableWidth: columnWidth,
    head: [['Ingreso Familiar (Promedio mensual)', 'Calificación']],
    body: ingresos.map(i => [i.ingreso, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const finalYIngresos = doc.lastAutoTable.finalY
  const columnWidth2 = 90
  const secondColumnX2 = 14 + columnWidth2 + gap

  autoTable(doc, {
    startY: startYTabla,
    margin: { left: secondColumnX2 },
    tableWidth: columnWidth2,
    head: [['Egreso Familiar (Promedio mensual)', 'Calificación']],
    body: egresos.map(i => [i.egreso, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 2,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const finalYEgresos = doc.lastAutoTable.finalY + 7

  // TABLA DE SALARIO MINIMO
  let salario = [
    { label: 'Salario Minimo', calif: 2 },
  ]

  // TABLA DE SITUACION ECONOMICA 
  let situacion = [
    { label: 'Equilibrio', calif: 2 },
  ]

  autoTable(doc, {
    startY: finalYEgresos,
    margin: { left: 14 },
    tableWidth: columnWidth,
    head: [['Salario', 'Calificación']],
    body: salario.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const columnWidth3 = 90
  const secondColumnX3 = 14 + columnWidth3 + gap

  autoTable(doc, {
    startY: finalYEgresos,
    margin: { left: secondColumnX3 },
    tableWidth: columnWidth3,
    head: [['Situación Económica', 'Calificación']],
    body: situacion.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const finalYEconomia = doc.lastAutoTable.finalY + 7

  // TABLA DE SALARIO MINIMO
  let vivienda = [
    { label: 'CASA/DEPTO. POPULAR', calif: 2 },
  ]

  // TABLA DE SITUACION ECONOMICA 
  let dormitorios = [
    { label: 'VIVIENDA CON UN DORMITORIO', calif: 2 },
  ]

  
  autoTable(doc, {
    startY: finalYEconomia,
    margin: { left: 14 },
    tableWidth: columnWidth,
    head: [['Tipo de Vivienda', 'Calificación']],
    body: vivienda.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const columnWidth4 = 90
  const secondColumnX4 = 14 + columnWidth4 + gap

  autoTable(doc, {
    startY: finalYEconomia,
    margin: { left: secondColumnX4 },
    tableWidth: columnWidth4,
    head: [['Número de Dormitorios', 'Calificación']],
    body: dormitorios.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const finalYVivienda = doc.lastAutoTable.finalY + 7

  y = finalYVivienda 
  y = campo(doc, 'Diagnóstico Social:', 'Paciente masculino pediatrico, limpio aseado, sin datos de descuido, en vivienda con buenas condiciones de higiene y servicios básicos disponibles, con ambos padres presentes en vida diaria. sin datos socioeconómicos de alarma, Paciente masculino pediatrico, limpio aseado, sin datos de descuido, en vivienda con buenas condiciones de higiene y servicios básicos disponibles, con ambos padres presentes en vida diaria. sin datos socioeconómicos de alarma,', 14, y, 186,6)

  const startYCalificaciones = y

  // TABLA DE SALARIO MINIMO
  let calificaciones = [
    { label: 'Grupo Familiar', calif: 2 },
    { label: 'Ocupación', calif: 2 },
    { label: 'Salario', calif: 2 },
    { label: 'Situación Económica', calif: 2 },
    { label: 'Tipo de Vivienda', calif: 2 },
    { label: 'Número de Dormitorios', calif: 2 },
    { label: 'Total de Puntos', calif: 2 },
  ]

  // TABLA DE SITUACION ECONOMICA 
  let escala = [
    { label: '4', calif: 4 },
  ]

  autoTable(doc, {
    startY: startYCalificaciones,
    margin: { left: 14 },
    tableWidth: columnWidth,
    head: [[
      { content: 'Calificación', colSpan: 2 }
    ]],
    body: calificaciones.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })

  const columnWidth5 = 90
  const secondColumnX5 = 14 + columnWidth5 + gap

  autoTable(doc, {
    startY: startYCalificaciones,
    margin: { left: secondColumnX5 },
    tableWidth: columnWidth5,
    head: [[
      { content: 'Escala de Clasificación', colSpan: 2 }
    ]],
    body: escala.map(i => [i.label, i.calif]),
    styles: {
      fontSize: 8,
      cellPadding: 1.5,
      lineWidth: 0.3,
      lineColor: [255, 255, 255]
    },
    headStyles: {
      fillColor: [230, 230, 230],
      textColor: 0,
      fontStyle: 'bold',
      halign: 'center'
    },
    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'center' }
    }
  })


  const lineaY = doc.lastAutoTable.finalY + 40
    doc.setFontSize(10)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(0)

    doc.line(pageWidth / 2 - 30, lineaY + 25    , pageWidth / 2 + 30, lineaY + 25)
    doc.text(formatMayusculas('JAVIER PEREZ REYES'), pageWidth / 2, lineaY + 30, { align: 'center' })
    doc.text('NOMBRE Y FIRMA DEL ENFERMERO', pageWidth / 2, lineaY + 35, { align: 'center' })



  // if (y + 40 > doc.internal.pageSize.height) {
  //   doc.addPage()
  //   y = 20
  // }

  doc.save('Ficha_Socioeconomica_Inicial.pdf')
}
export { generarFichaSocioeconomica }